import React from "react";
import { formLink, privacyPolicyLink, termsAndConditionsLink } from "../Paths/paths";

const TermsAndConditionsModal = () => {
        return <>
            <p><b>The Directory has been updated and use of the Directory is subject to new Terms and Conditions.</b></p>
            <p><b>IMPORTANT:{' '}</b>Each company must agree to the <a href={termsAndConditionsLink}>Directory Terms and Conditions</a> before it, and its authorised users, can use the Directory.</p>
            <p>By clicking "accept", you confirm that either (as applicable):
                <br />
                (a) As a first user of the Directory from your company you are authorised to accept these Directory Terms and Conditions on behalf of your company and have the required authority to bind your company – please check with the primary administrator appointed by your company.</p>
            <p>OR</p>
            <p>(b) You have been assigned as an authorised user by your company who has already validly accepted these Directory Terms and Conditions. You also acknowledge that you have read and agree to comply with these Directory Terms and Conditions.</p>
            <p>Please review the <a href={privacyPolicyLink}>Directory Privacy Policy</a> which sets out how BRCGS processes user's personal data.</p>
            <p>If you have any questions on these documents, please fill in the <a href={formLink}>form.</a></p>
        </>
}

export default TermsAndConditionsModal